export default class GudangModel {
    constructor({ id, name, dc, link_maps, pallet, language, employees, is_active, created_by, created_by_name, created_on }) {
        this.id = id;
        this.name = name;
        this.dc = dc;
        this.link_maps = link_maps;
        this.total_pallet_positions = pallet;
        this.total_employees = employees;
        this.language = language;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
        this.created_on = created_on;
    }
}